/*
 * SPDX-FileCopyrightText: 2026 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useNoteSettingsContext } from '../note-settings/note-settings-context'
import { PermissionSectionOwner } from './permission-section-owner'
import { PermissionSectionSpecialGroups } from './permission-section-special-groups'
import { PermissionSectionUsers } from './permission-section-users'
import { PermissionSectionVisibility } from './permission-section-visibility'
import React, { Fragment } from 'react'

/**
 * Renders all sections for viewing and managing the permissions of the note given by the surrounding
 * {@link NoteSettingsProvider}. Only the owner of the note can change the permissions.
 */
export const NotePermissionsSections: React.FC = () => {
  const { isOwner } = useNoteSettingsContext()
  return (
    <Fragment>
      <PermissionSectionOwner disabled={!isOwner} />
      <PermissionSectionUsers disabled={!isOwner} />
      <PermissionSectionSpecialGroups disabled={!isOwner} />
      <PermissionSectionVisibility disabled={!isOwner} />
    </Fragment>
  )
}
